import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {UtilisateurCourantService} from '../services/utilisateurs/utilisateur-courant.service';
import {tap} from 'rxjs/operators';
import {NavigationService} from '../navigation/services/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuard  {
  constructor(
    private userService: UtilisateurCourantService,
    private router: Router,
    private navigationService: NavigationService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.userService.isLogguedIn().pipe(
      tap(isLogged => {
        if (!isLogged) {
          this.navigationService.root.login.navigate(state.url);
        }
      }),
    );
  }
}
